import { computed } from 'vue'
import {useTapStore} from "@/stores/tapStore.js";

export function useComponents() {
    const tapStore = useTapStore()
    const blocks = computed(() => tapStore.currentTapLang.blocks)

    const getBlockById = (uniqueId) => blocks.value.find((b) => b.uniqueId === uniqueId)
    const normalize = (components, block) => {
        let blockChanged = false;
        components.forEach((c, i) => {
            c.changed = c.changed || c.orderIndex !== i +1
            c.orderIndex = i + 1
            if(c.changed) blockChanged = true;
        })

        if(blockChanged) {
            block.changed = true;
            tapStore.currentTapLang.changed = true;
        }
    }

    const cleanupEmptyBlocks = (reorderComponent = false) => {
        const filtered = blocks.value.filter(b => b.blockItems.length > 0)
        filtered.forEach((b, i) => {
            b.orderIndex = i + 1
            b.changed = b.changed || b.orderIndex !== i + 1
            if (reorderComponent) normalize(b.blockItems, b)
        })
        tapStore.currentTapLang.blocks = filtered
    }

    const moveComponent = (blockIdUniqueId, uniqueId, directionUp) => {
        const tapApi = useTapApi();

        const blockIndex = blocks.value.findIndex(b => b.uniqueId === blockIdUniqueId)
        if (blockIndex === -1) return
        const block = blocks.value[blockIndex]

        const arr = block.blockItems
        const index = arr.findIndex(c => c.uniqueId === uniqueId)

        if (index === -1) return

        const isFirst = index === 0
        const isLast = index === arr.length - 1

        if (directionUp && isFirst) {
            const prevBlock = blocks.value[blockIndex - 1]
            if (!prevBlock) return

            const [comp] = arr.splice(index, 1)
            normalize(arr, block)

            comp.moveUp = true
            prevBlock.blockItems.push(comp)
            setTimeout(() => {
                comp.moveUp = false
            }, 300)

            normalize(prevBlock.blockItems, prevBlock)
            tapStore.markTapListDirty()
            tapApi.moveComponent(tapStore.currentTap.projectVersion.id, {
                uniqueId: uniqueId,
                sourceBlockUniqueId: block.uniqueId,
                targetBlockUniqueId: prevBlock.uniqueId,
                aboveOrderIndex: prevBlock.blockItems.length - 1
            }, tapStore.currentTapLang.lang)
            cleanupEmptyBlocks()
            return
        }

        if (!directionUp && isLast) {
            const nextBlock = blocks.value[blockIndex + 1]
            if (!nextBlock) return

            const [comp] = arr.splice(index, 1)
            normalize(arr, block)

            nextBlock.blockItems.unshift(comp)
            normalize(nextBlock.blockItems, nextBlock)
            tapStore.markTapListDirty()
            tapApi.moveComponent(tapStore.currentTap.projectVersion.id, {
                uniqueId: uniqueId,
                sourceBlockUniqueId: block.uniqueId,
                targetBlockUniqueId: nextBlock.uniqueId,
                aboveOrderIndex: 0
            }, tapStore.currentTapLang.lang)
            cleanupEmptyBlocks()
            return
        }

        const newIndex = directionUp ? index - 1 : index + 1
        if (newIndex < 0 || newIndex >= arr.length) return

        const tmp = arr[newIndex]
        arr[newIndex] = arr[index]
        arr[index] = tmp

        saveMoveComponent(block.uniqueId, uniqueId, newIndex)

        normalize(arr, block)
    }

    const saveMoveComponent = (blockUniqueId, uniqueId, newIndex) => {
        const tapApi = useTapApi();
        tapStore.markTapListDirty()
        tapApi.moveComponent(tapStore.currentTap.projectVersion.id, {
            uniqueId: uniqueId,
            aboveOrderIndex: newIndex,
            targetBlockUniqueId: blockUniqueId,
        }, tapStore.currentTapLang.lang)
    }

    const removeComponent = (blockIdUniqueId, uniqueId) => {
        const tapApi = useTapApi();
        const block = getBlockById(blockIdUniqueId)
        if (!block) return

        const index = block.blockItems.findIndex(c => c.uniqueId === uniqueId)
        if (index !== -1) {
            block.blockItems.splice(index, 1)
            block.changed = true;
            normalize(block.blockItems, block)
        }

        cleanupEmptyBlocks()
        tapStore.currentTapLang.changed = true;
        tapStore.markTapListDirty()
        tapApi.removeComponent(tapStore.currentTap.projectVersion.id, uniqueId, tapStore.currentTapLang.lang)
    }

    return {
        blocks,
        moveComponent,
        removeComponent,
        normalize,
        cleanupEmptyBlocks,
        saveMoveComponent
    }
}
